import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ClosedAccountLayer from "../../../components/Admin/ClosedAccountLayer";

const ClosedAccount = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ClosedAccountLayer />
      </MasterLayout>
    </>
  );
};
export default ClosedAccount
